module.exports = __webpack_public_path__ + "static/assets/76121b7f4eff7d7ca0d49a45479d3f3f.svg";